import { TRIAL_PERIOD_DAYS } from '@aloft/toolkit-shared';
import { Block, Flex, Link, Typography } from '@aloft/toolkit-sui';

import { useBreakpoints } from '../../../hooks/useBreakpoints.ts';
import { Plan } from '../types.ts';
import { PlanCard, PlanCardProps } from './PlanCard.tsx';

type PricingTableProps = {
  plans: Plan[];
  showTrial?: boolean;
  onPlanSelect: PlanCardProps['onPlanSelect'];
};

export const PricingTable = ({ plans, showTrial, onPlanSelect }: PricingTableProps) => (
  <TrialBanner showBanner={!!showTrial}>
    <Flex width="100%" justifyContent="center" gap="36px" flexWrap="wrap">
      {plans.map((plan) => (
        <PlanCard key={plan.id} onPlanSelect={onPlanSelect} showTrial={showTrial} {...plan} />
      ))}
    </Flex>
    {showTrial && (
      <Block marginTop="30px">
        <Typography variant="body1" textAlign="center" __dangerDoNotUseSx={{ fontSize: '0.95rem' }}>
          Are you a Trainee?&nbsp;
          <Link isExternal href="https://airtable.com/appOPM30b7Ln0KlIR/pagGyc1PGsc4aa3aU/form">
            Contact us
          </Link>
          &nbsp;after signing up for continued free access to Appraiser Toolkit after your trial!
        </Typography>
      </Block>
    )}
  </TrialBanner>
);

const TrialBanner = ({
  showBanner,
  children,
}: React.PropsWithChildren<{ showBanner: boolean }>) => {
  const { isTabletAndBelow } = useBreakpoints();

  return (
    <Flex width="100%" flexDirection="column" alignItems="center" padding="16px">
      {showBanner && (
        <Block
          width={isTabletAndBelow ? '100%' : '75%'}
          maxWidth="800px"
          borderRadius="6px"
          textAlign="center"
          padding="20px"
          paddingBottom="75px"
          paddingTop="55px"
          __dangerDoNotUseSx={{
            backgroundColor: '#142F52',
            color: 'white',
          }}
        >
          <Typography variant={isTabletAndBelow ? 'displaySmall' : 'displayMedium'}>
            {TRIAL_PERIOD_DAYS.toLocaleString()}-Day Free Trial
          </Typography>
        </Block>
      )}
      <Block marginTop={showBanner ? '-40px' : undefined}>{children}</Block>
    </Flex>
  );
};
